import { SORT_OPTIONS } from "@/utils/applicationConstants";
import { sharedService } from "@/modules/shared/store/services/shared-service";
import { RECEIVE_GET_LOAN_TYPES } from "@/redux/constants/loan_types";

const DEFAULT_FILTERS = { page: 1, size: 30, sortBy: SORT_OPTIONS[0].id, searchTerm: "" };

const getLoanTypes = sharedService.injectEndpoints({
  endpoints: builder => ({
    getLoanTypes: builder.query({
      query: () => {
        const params = new URLSearchParams();
        Object.entries(DEFAULT_FILTERS).forEach(([k, v]) => { if (v) params.set(k, v); });
        return `parameters/loan-types?${params}`;
      },
      transformResponse: response => response.items,
      providesTags: ["LoanTypes"],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch({ type: RECEIVE_GET_LOAN_TYPES, loanTypes: data });
        } catch { /* handled by RTK Query error state */ }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetLoanTypesQuery } = getLoanTypes;

